import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {environment} from '../../../../containers/environment';
import { FullWideNotification } from '../../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

const Ava = `${process.env.PUBLIC_URL}/img/profile-photo.png`;
const minerBook = `${process.env.PUBLIC_URL}/img/minerBook.png`;

class ProfileMain extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      user: {},
    };
  }

  componentDidUpdate(prevProps) {
    if(prevProps.user !== this.props.user){
      this.setState({ user: this.props.user});
    }
  }
  
  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let totalProcessos = 0;
    let totalRequerimentos = 0;
    let totalServicos = 0;
    
    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <CardBody className="profile__card">
            <div className="profile__information">
              {/* <div className="profile__avatar">
                <img src={Ava} alt="avatar" />
              </div> */}
              <div className="profile__minerbook_img">
                <img src={minerBook} alt="MinerBook" />
              </div>
              <div className="profile__data_user">
                <p className="profile__name">{ this.state.user.firstName + ' ' +  this.state.user.lastName }</p>
                <p className="profile__work">{t('forms.'+environment.getProfileNameLng())}</p>
                <p className="profile__contact">{ this.state.user.email }</p>
                <p className="profile__contact" dir="ltr">{ this.state.user.phone }</p>
              </div>
              {/* <div className="profile__minerbook_img">
                <img src={minerBook} alt="MinerBook" />
              </div> */}
            </div>
            <div className="profile__stats">
              <div className="profile__stat">
                <p className="profile__stat-number">{totalProcessos}</p>
                <p className="profile__stat-title">{t('forms.processos')}</p>
              </div>
              <div className="profile__stat">
                <p className="profile__stat-number">{totalRequerimentos}</p>
                <p className="profile__stat-title">{t('forms.requerimentos')}</p>
              </div>
              <div className="profile__stat">
                <p className="profile__stat-number">{totalServicos}</p>
                <p className="profile__stat-title">{t('forms.services')}</p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

  export default reduxForm({
    form: 'profile_form_edit', // a unique identifier for this form
  })(withTranslation('common')(ProfileMain));
